import { Route, Routes } from 'react-router-dom';
import { PublicClubRouteShell } from '@/components/public/PublicClubRouteShell';
import { OrgCourtsHubLayout } from '@/components/public/org/OrgCourtsHubLayout';
import { CourtHireMyBookingsTab } from '@/components/public/org/CourtHireMyBookingsTab';
import { PublicClubCourtHireEmbedded } from '@/pages/public/PublicClubCourtHirePage';

export default function OrgCourtsHubPage() {
  return (
    <PublicClubRouteShell>
      <Routes>
        <Route element={<OrgCourtsHubLayout />}>
          <Route index element={<PublicClubCourtHireEmbedded />} />
          <Route path="bookings" element={<CourtHireMyBookingsTab />} />
        </Route>
      </Routes>
    </PublicClubRouteShell>
  );
}
